module.exports = __webpack_public_path__ + "static/img/zxzw-bzjp-mll.ffd5075.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/zxzw-bzjp-mll.png
// module id = 372
// module chunks = 32